import _export from '../internals/export.js';
import functionUncurryThis from '../internals/function-uncurry-this.js';
import fails$1 from '../internals/fails.js';
import thisNumberValue$1 from '../internals/this-number-value.js';

var $ = _export;
var uncurryThis = functionUncurryThis;
var fails = fails$1;
var thisNumberValue = thisNumberValue$1;
var un$ToPrecision = uncurryThis(1.0.toPrecision);
var FORCED = fails(function () {
  // IE7-
  return un$ToPrecision(1, undefined) !== '1';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  un$ToPrecision({});
}); // `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision

$({
  target: 'Number',
  proto: true,
  forced: FORCED
}, {
  toPrecision: function toPrecision(precision) {
    return precision === undefined ? un$ToPrecision(thisNumberValue(this)) : un$ToPrecision(thisNumberValue(this), precision);
  }
});
